import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { Common } from 'app/model/entity/common';
import { CommonService } from 'app/service/common.service';
import { DateTime } from 'luxon';
@Pipe({
  name: 'localTime'
})
export class LocalTimePipe extends DatePipe implements PipeTransform {
  private commonObject: Common;

  constructor(@Inject(LOCALE_ID) locale: string, private commonService: CommonService) {
    super(locale);
    this.commonObject = commonService.getCommonObject();
  }

  transform(value: any, format?: string): string {
    return DateTime.fromISO(value, { zone: 'utc' })
      .plus({
        hours: this.commonObject.setting.timezone.offsetHour,
        minutes: this.commonObject.setting.timezone.offsetMinute
      })
      .toFormat(format);
  }
}
